export { default as api, CALL_API } from './api'
export { default as checkToken } from './checkToken'
export { default as setToken } from './setToken'


// WEBPACK FOOTER //
// ./src/middlewares/index.js